import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { toast } from "sonner";

export default function StaffDashboard() {
  const { user, loading } = useApp();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!loading) {
      if (!user) navigate("/login");
      else if (user.role !== "staff" && user.role !== "admin") navigate("/dashboard");
    }
  }, [user, loading, navigate]);

  useEffect(() => {
    if (!user) return;
    (async () => { const r = await api.get("/staff/today"); setItems(r.data); })();
  }, [user]);

  const updateStatus = async (id, status) => {
    await api.post(`/admin/bookings/${id}/status`, { status });
    setItems(items.map(i => i.booking_id === id ? { ...i, status } : i));
    toast.success("Updated");
  };

  return (
    <div>
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
        <h1 className="font-heading text-3xl font-bold">Staff Dashboard</h1>
        <p className="text-slate-500">Today&apos;s appointments and bookings</p>
        <div className="mt-6 space-y-3">
          {items.length === 0 && <p className="text-slate-500">No appointments today</p>}
          {items.map(b => (
            <div key={b.booking_id} className="bg-white rounded-2xl card-shadow p-5 flex flex-wrap items-center gap-4">
              <div className="flex-1 min-w-[200px]">
                <div className="flex items-center gap-2">
                  <span className="chip bg-blue-100 text-blue-700 uppercase">{b.service_type}</span>
                  <span className="text-xs text-slate-500">Token: {b.token_number}</span>
                </div>
                <div className="mt-1 font-medium">{b.patient?.name} · {b.patient?.age}yr</div>
                <div className="text-sm text-slate-500">{b.slot_time} · {b.doctor_name || b.test_name}</div>
              </div>
              <select value={b.status} onChange={e => updateStatus(b.booking_id, e.target.value)}
                className="rounded-lg border px-3 py-2 text-sm">
                <option>pending</option><option>confirmed</option><option>completed</option><option>cancelled</option>
              </select>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
